module.exports = new __parcel__URL__("select-asana-board.c6617f90.svg").toString();